import { SxProps, Theme } from '@mui/material';

const navLinkButton: SxProps<Theme> = {
  width: 112,
  height: '56px',
  marginRight: 1,
  color: 'white',
  borderRadius: 0,
  ':hover': {
    backgroundColor: 'customGrey.light',
    color: 'customGrey.dark'
  }
};

const selectedNavLinkButton: SxProps<Theme> = {
  ...navLinkButton,
  backgroundColor: 'background.default',
  color: 'text.primary',
  fontWeight: 'bold',
  textDecoration: 'none',
  ':hover': {
    backgroundColor: 'customGrey.light',
    color: 'customGrey.dark'
  }
};

const toolbar: SxProps<Theme> = {
  width: '100%',
  justifyContent: 'space-between',
  px: 0
};

export const navbarSx = {
  navLinkButton,
  selectedNavLinkButton,
  toolbar
};
